import React from "react";
import { withRouter } from "react-router";
import { Redirect, Link } from "react-router-dom";

import MPage from "../templates/mpage";
import useObtenerMunicipio from "../../utils/useObtenerMunicipio";
import data from "../../preguntasrespuestas.json";

const Info = (props) => {
  const [municipio, error] = useObtenerMunicipio(props.match.params.munUrl);

  if (error === true) return <Redirect to="/" />;
  if (municipio === undefined) return null;

  const pregResp = data[municipio.nombreUrl];

  return (
    <MPage municipio={municipio}>
      <h2 className="centrado font-weight-light mt-4 mb-2">
        Sobre Nuestro Presupuesto Participativo
      </h2>
      {pregResp.map((info, index) => (
        <div className="card m-3" key={index}>
          <div className="card-header">{info.titulo}</div>
          <div className="card-body">
            {info.texto.map((parrafo, index) => (
              <p className="card-text" key={index}>
                {parrafo}
              </p>
            ))}
          </div>
        </div>
      ))}

      <div className="card m-3">
        <div className="card-header">Anexos</div>
        {municipio.docs.map((doc) => (
          <a
            className="ppr-a m-3"
            key={doc}
            href={`/docs/${doc}`}
            target="_blank"
            rel="noopener noreferrer"
            download
          >
            {doc}
          </a>
        ))}
      </div>

      <center className="mb-3">
        <Link
          to={"/municipio/" + municipio.nombreUrl}
          className="btn ppr-btn-verde font-weight-bold m-2"
        >
          Volver
        </Link>
      </center>
    </MPage>
  );
};

export default withRouter(Info);
